// Mundely Firebase Test fallback configuration.
// Firebase web configuration is public client configuration, not a private secret.
// VITE_* environment variables always have precedence over this durable fallback.
export const firebaseDefaults = {
  apiKey: "AIzaSyAa02zUusbTY9UJMHCvwTqppo-CesZOW24",
  authDomain: "auth-test.mundely.it",
  projectId: "tripai-test-ccb16",
  storageBucket: "tripai-test-ccb16.firebasestorage.app",
  messagingSenderId: "739982551474",
  appId: "1:739982551474:web:b001f8ce602a8979075cab",
  measurementId: ""
} as const;
